import type { IEvent } from 'api/interfaces/events/interfaces.model'
import type { IOrganization } from 'api/interfaces/organizations/interfaces.model'
import type { IProgram } from 'api/interfaces/programs/interfaces.model'
import { PresentationCard } from 'components/atoms/PresentationCard'
import { TypographyFooter } from 'components/atoms/PresentationCard/PresentationCard.styled'
import { SLink } from 'MainContainer/styles/Navbar.styled'
import type { FC } from 'react'
import React, { useMemo } from 'react'
import { pathENUM } from 'registrators/registrators'

import {
  SHeader,
  SHeaderProgram,
  SHeaderWrapper,
} from '../../../styles/pages.styled'
import { objectsNameENUM } from '../../Map.model'

interface IContentPanelContainerProps {
  dataForPanel: any
  selectedType?: objectsNameENUM
}

export const ContentPanelContainer: FC<IContentPanelContainerProps> = ({
  dataForPanel,
  selectedType,
}) => {
  const contentPanel = useMemo(() => {
    if (!dataForPanel.length) {
      return null
    }
    if (selectedType && selectedType === objectsNameENUM.events) {
      return dataForPanel.map((event: IEvent) => (
        <SLink
          key={`${event.activity_main_info.id}_${event.activity_main_info.name}`}
          href={`${pathENUM.events}/${event.activity_main_info.id}`}>
          <PresentationCard
            header={
              <TypographyFooter>
                {event.activity_main_info.name}
              </TypographyFooter>
            }
            footer={
              <TypographyFooter>
                {event.activity_main_info.age_pupil} лет
              </TypographyFooter>
            }
            body={
              <SHeaderWrapper>
                <SHeaderProgram>
                  Адрес: {event.activity_main_info.addresses[0].address_str}
                </SHeaderProgram>
                <SHeaderProgram>
                  {`Контакты: ${event.activity_main_info.organizator.phone}, ${event.activity_main_info.organizator.email}`}
                  <SHeaderProgram>
                    {`Организация: ${event.activity_main_info.organizator.unit_public_name}`}
                  </SHeaderProgram>
                </SHeaderProgram>
              </SHeaderWrapper>
            }
          />
        </SLink>
      ))
    }
    if (selectedType && selectedType === objectsNameENUM.programs) {
      return dataForPanel.map((program: IProgram) => (
        <SLink
          key={`${program.activity_main_info.id}_${program.activity_main_info.name}`}
          href={`${pathENUM.programs}/${program.activity_main_info.id}`}>
          <PresentationCard
            header={
              <TypographyFooter>
                {program.activity_main_info.name}
              </TypographyFooter>
            }
            body={
              <SHeaderWrapper>
                <SHeaderProgram>
                  Адрес: {program.activity_main_info.addresses[0].address_str}
                </SHeaderProgram>
                <SHeaderProgram>
                  Контакты: {program.organizator.phone}{' '}
                  {program.organizator.email}
                </SHeaderProgram>
                <SHeaderProgram>
                  Организация: {program.organizator.unit_name}
                </SHeaderProgram>
              </SHeaderWrapper>
            }
            footer={
              <TypographyFooter>
                {program.activity_main_info.age_pupil}
              </TypographyFooter>
            }
          />
        </SLink>
      ))
    }
    if (selectedType === objectsNameENUM.organizations) {
      const organizationsWithoutRepeat = dataForPanel.filter(
        (item: IOrganization, index: number, organisations: IOrganization[]) =>
          organisations.findIndex(
            (element: IOrganization) =>
              element.main_info.unit_id === item.main_info.unit_id,
          ) === index,
      )
      return organizationsWithoutRepeat.map((organization: IOrganization) => (
        <SLink
          key={organization.main_info.unit_id}
          href={`${pathENUM.organizations}/${organization.main_info.unit_id}`}>
          <PresentationCard
            preheader={<SHeader>{organization.main_info.unit_name}</SHeader>}
          />
        </SLink>
      ))
    }
    return null
  }, [dataForPanel, selectedType])
  return <>{contentPanel}</>
}
